import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip } from "@mui/material";
import { Adjust, Check } from "mdi-material-ui";
import { getIssuesColor, IssueTranslation } from "../index.js";
export function IssuesIcon({ issues, club, ...props }) {
    const { htmlColor, isActive } = getIssuesColor(issues, club);
    const internalIssues = [
        !isActive && { name: "inactive" },
        ...issues.filter((issue) => issue.name !== "allPlayersHaveNotSignedMemberships" &&
            issue.name !== "hasEconomy"),
    ];
    return (_jsx(Tooltip, { title: internalIssues.map((issue) => issue && (_jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [issue.approved && (_jsx(Check, { fontSize: "inherit", color: "inherit", sx: { mr: 0.5 } })), _jsx(IssueTranslation, { issue: issue })] }, issue.name))), children: _jsx(Adjust, { htmlColor: htmlColor, ...props }) }));
}
//# sourceMappingURL=IssuesIcon.js.map